import React from "react";
import { Col, Row } from "react-bootstrap";

const Banner = () => {
  return (
    <>
      <Row>
        <Col xs={12} md={9}>
          <p className="banner-heading">
            Order Ferrous and Non-Ferrous <br /> commodities on Metalbook
          </p>
        </Col>
      </Row>
    </>
  );
};

export default Banner;
